export default __webpack_public_path__ + "static/media/rr4.66c5f5aa.jpg";